import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Visibility & scroll states
  const [isVisible, setIsVisible] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  // Mobile states
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Scroll logic
  useEffect(() => {
    const controlNavbar = () => {
      const currentScrollY = window.scrollY;

      setIsScrolled(currentScrollY > 10);

      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", controlNavbar);
    return () => window.removeEventListener("scroll", controlNavbar);
  }, [lastScrollY]);

  // Resize listener for 900px breakpoint
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 900;
      setIsMobile(mobile);
      if (!mobile) setMobileMenuOpen(false);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Smooth scroll helper
  const scrollToSection = (sectionId) => {
    setMobileMenuOpen(false);

    const scroll = () => {
      const element = document.getElementById(sectionId);
      if (!element) return;

      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({ top: offsetPosition, behavior: "smooth" });
    };

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(scroll, 100);
    } else {
      scroll();
    }
  };

  return (
    <header
      className={`
        fixed top-0 z-50 w-full transition-all duration-300 transform
        ${isVisible ? "translate-y-0" : "-translate-y-full"}
        ${isScrolled ? "backdrop-blur-md bg-white/80" : "bg-white"}
      `}
    >
      {/* CONSTRAINED CONTAINER */}
      <div className="max-w-[1440px] mx-auto px-6 sm:px-8 md:px-12 lg:px-20 h-16 flex items-center justify-between">
        {/* Logo */}
        <div
          onClick={() => navigate("/")}
          className="flex items-center cursor-pointer"
        >
          <img
            src="./images/alldoer-logo.svg"
            alt="Alldoer Logo"
            className="h-8 w-auto object-contain"
          />
        </div>

        {/*DESKTOP NAV  */}
        {!isMobile && (
          <>
            <nav className="flex items-center space-x-8">
              <button onClick={() => scrollToSection("works")} className="header-link">
                How It Works
              </button>
              <button onClick={() => scrollToSection("catalogue")} className="header-link">
                Our Catalogue
              </button>
              <button onClick={() => scrollToSection("why-us")} className="header-link">
                Why Choose Us
              </button>
              <button onClick={() => scrollToSection("contact")} className="header-link">
                Contact Us
              </button>
            </nav>

            <button
              onClick={() => navigate("/start-brand")}
              className="bg-slate-800 hover:bg-slate-900 text-white text-sm font-medium px-5 py-2.5 rounded flex items-center shadow-sm transition-colors"
            >
              <img src="./icons/alldoer-star.svg" alt="" className="w-4 h-4 mr-2" />
              Start Sourcing
            </button>
          </>
        )}

        {/* MOBILE HAMBURGER*/}
        {isMobile && (
          <button
            onClick={() => setMobileMenuOpen((prev) => !prev)}
            aria-label="Toggle Menu"
            className="text-gray-800"
          >
            {mobileMenuOpen ? (
              <svg width="24" height="24" fill="none" stroke="currentColor">
                <path strokeWidth="2" strokeLinecap="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg width="24" height="24" fill="none" stroke="currentColor">
                <path strokeWidth="2" strokeLinecap="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        )}
      </div>

      {/*  MOBILE MENU */}
      {isMobile && mobileMenuOpen && (
        <div className="bg-white border-t border-gray-200 shadow-md">
          <div className="max-w-[1440px] mx-auto px-6 sm:px-8 md:px-12 lg:px-20 py-6">
            <nav className="flex flex-col gap-5 text-sm font-medium text-gray-700">
              <button onClick={() => scrollToSection("works")}>How It Works</button>
              <button onClick={() => scrollToSection("catalogue")}>Our Catalogue</button>
              <button onClick={() => scrollToSection("why-us")}>Why Choose Us</button>
              <button onClick={() => scrollToSection("contact")}>Contact Us</button>

              <div className="h-px bg-gray-200 my-2" />

              <button
                onClick={() => {
                  setMobileMenuOpen(false);
                  navigate("/start-brand");
                }}
                className="bg-slate-800 hover:bg-slate-900 text-white px-5 py-3 rounded flex items-center justify-center"
              >
                <img src="./icons/alldoer-star.svg" alt="" className="w-4 h-4 mr-2" />
                Start Sourcing
              </button>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
